import { connect } from 'react-redux';
import ViewDropdown from '../../worklist/components/toolbar/view-dropdown';
import { updateView, updateGanttViews } from '../../common/gantt/containers/gantt-actions';

const mapStateToProps = state => ({
  views: state.gantt.views,
  activeView: state.gantt.activeView,
  isLoadingViews: state.gantt.isLoadingViews,
  isSavingViews: state.gantt.isSavingViews,
  activeFilters: state.gantt.activeFilters,
  activeSort: state.gantt.activeSort,
  range: state.gantt.view,
});


const mapDispatchToProps = {
  updateView,
  updateViews: updateGanttViews,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ViewDropdown);
